import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'
import CustomLink from '../CustomLink/CustomLink';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../firebase.init';
import { signOut } from 'firebase/auth';

const Header = () => {

    const [user] = useAuthState(auth);

    const logout = () => {

        signOut(auth);

    }

    return (
        <div>
            <nav class="navbar navbar-expand-lg navbar-light bg-dark">
                <div class="container">
                    <a class="navbar-brand text-white" href="#">Discovery Bangladesh</a>
                    <button class="navbar-toggler text-white bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon text-white"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <CustomLink to={'/'}>Home</CustomLink >
                            </li>
                            <li class="nav-item">
                                <CustomLink to={'/about'}>About</CustomLink >
                            </li>
                            <li class="nav-item dropdown mt-1">
                                <a class="nav-link text-white dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Travel BD
                                </a>
                                <ul class="dropdown-menu text-white " aria-labelledby="navbarDropdownMenuLink">
                                    <li><a class="dropdown-item " href="#">Dhaka</a></li>
                                    <li><a class="dropdown-item" href="#">Chattagram</a></li>
                                    <li><a class="dropdown-item" href="#">Rajshahi</a></li>
                                    <li><a class="dropdown-item" href="#">Khulna</a></li>
                                    <li><a class="dropdown-item" href="#">Jessore</a></li>

                                </ul>
                            </li>
                            <li class="nav-item mt-1">
                                <a class=" text-white nav-link" href="#">Travel Services</a>
                            </li>

                            <li class="nav-item mt-0">
                                <CustomLink to={'/blogs'}>Blogs</CustomLink >
                            </li>
                            <li class="nav-item mt-1">
                                <a class=" text-white nav-link" href="#">Contact Us</a>
                            </li>
                            <li class="nav-item mt-1">
                                {
                                    user ? <button onClick={logout} className='btn btn-success'>Log out</button> :
                                        <CustomLink to={'/checkout'}>Checkout</CustomLink >
                                }

                            </li>
                            <li class="nav-item">
                                <CustomLink to={'/login'}>Login</CustomLink >
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Header;